import React, {Component, PropTypes} from 'react';
import {
  Button,
  Modal,
  FormGroup,
  Form,
  Col,
  FormControl,
  ControlLabel,
} from '@sketchpixy/rubix';
import styled from 'styled-components';
import {ClipLoader} from 'react-spinners';
import {css} from 'react-emotion';

import ServiceType from '../../../constants/ServiceType';

import {
	uploadRapaelClient
} from '../../../api/api';

const override = css`
margin-top: -550px;
`;

class UploadRapaelClientModal extends Component {
  constructor(props) {
    super(props);

    this.onFileChange = this.onFileChange.bind(this);

    this.state = {
      file:'',
      loading: false
    };
  }

  onFileChange(e) {
    this.setState({
      file: e.target.files[0],
    });
  }


  uploadRapaelClient = (event) => {
     let self = this;
     const formData = new FormData();
     if(self.state.file !== '')
     {
         formData.append('file',self.state.file);
     }

     self.setState({
         loading: true,
     });
     uploadRapaelClient(formData, (err, res) => {
         self.setState({
             loading: false,
         });
         if (err) {
            vex.dialog.alert('Failed to update Content!');
          } else {
            vex.dialog.alert('Content Updated!');
          }
     });
  }

  onShowModal = (evt) => {

  }

  render() {
    return (
        <Modal
            show={this.props.showModal}
            onHide={this.props.closeModal}
            onEntered = {this.onShowModal}
            backdrop="static"
            style={{width:'100%'}}
        >
          <Modal.Header closeButton>
            <Modal.Title>Upload Messgae</Modal.Title>
          </Modal.Header>
          <Modal.Body>
             <Form>
                 <FormGroup controlId="formControlsFile">
                      <ControlLabel>Attach Message Excel</ControlLabel>
                      <FormControl type="file" name="file" onChange={this.onFileChange}/>
                 </FormGroup>
             </Form>
             <ClipLoader
             className={override}
             sizeUnit={'px'}
             size={500}
             color={'#123abc'}
             loading={this.state.loading}>
             </ClipLoader>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle='primary' onClick={this.uploadRapaelClient}>Save</Button>
            <Button onClick={this.props.closeModal}>Cancel</Button>
          </Modal.Footer>
        </Modal>
    );
  }
}

UploadRapaelClientModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired
};

export default UploadRapaelClientModal;



// WEBPACK FOOTER //
// ./src/routes/ReleaseMgnt/components/UploadRapaelClientModal.js